import { useState, useEffect } from 'react';
import "./FormRenameModal.css";
import Modal from "../shared/Modal";

type FormRenameModalProps = {
    isOpen: boolean;
    defaultValue: string;
    onClose: () => void;
    onSubmit: (name: string) => void;
}

export const FormRenameModal = ({isOpen, onClose, onSubmit, defaultValue}: FormRenameModalProps) => {

    const [name, setName] = useState<string>(defaultValue);
    // console.log("[FormRenameModal] isOpen: ", isOpen);

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="form-rename-container">

                <div className="modal-title">
                    Rename form
                </div>
                
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoFocus={true}
                />

                

                <div className="modal-buttons">
                    <button 
                        className="button-cancel"
                        onClick={onClose}
                    >
                            Cancel
                    </button>
                    <button
                        className="button-save"
                        onClick={() => {
                            onSubmit(name);
                        }}
                        disabled={name === ""}
                    >
                        Submit
                    </button>
                </div>
                

              
            </div>
      </Modal>
    )
}